export default {
  departmentList: [],
  objDepartmentEdit: [],
  departmentRangesList: [],
  productCodes: [],
  departmentUsers: [],
  departmentStatuses: [],
  departmentLoader: false,
  departmentUsedRanges: '',
  userBranchesDepartments: [],
  lookupArray: []
}
